export default "__VITE_ASSET__DlVV1X2l__"